import { IApplicationState } from '../../../types/redux';

/**
 * Выбирает список комментов для карточки поста
 */
export const selectComments = ({ postCardNew: { comments } }: IApplicationState) => comments;
